import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductKeysType } from '../../model';

const initialState: ProductKeysType[] = [];

const sliceProductKeys = createSlice({
  name: 'productKeys',
  initialState,
  reducers: {
    updateProductKeys(state, action: PayloadAction<ProductKeysType[]>) {
      state = action.payload;
      return state;
    }
  }
});

// export actions
export const { updateProductKeys } = sliceProductKeys.actions;
// export named reducer (for nicer syntax in store)
export const { reducer: reducerProductKeys } = sliceProductKeys;
